module.exports = __webpack_public_path__ + "img/side-bar-logo-black.dc4b1341.png";